"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _default = exports.default = {
  Image: _styledComponents.default.img`
    width: 100%;
    display: block;
  `,
  ContentBlock: _styledComponents.default.div`
    padding: 20px 30px 20px 20px;
    ${function (_ref) {
    let {
      brand
    } = _ref;
    return brand === "toyota" && `border: 1px solid #d8d8d8;`;
  }}
  `,
  CloseButton: _styledComponents.default.div`
    position: absolute;
    top: 0;
    right: 0;
    ${function (_ref2) {
    let {
      brand
    } = _ref2;
    return brand === "toyota" && `padding: 16px;`;
  }}
  `,
  PlainText: _styledComponents.default.button`
    font: inherit;
    padding: 0;
    margin: 0;
    border: none;
    cursor: pointer;
  `,
  InfoIcon: _styledComponents.default.button`
    display: block;
    background: transparent;
    border: none;
    cursor: pointer;
    position: relative;
    width: 20px;
    height: 20px;
    padding: 1px;
    box-sizing: content-box;
  `,
  MoreInfoContent: _styledComponents.default.div`
    width: 100vw;
    max-width: 100%;
  `,
  CtaListContainer: _styledComponents.default.div`
    padding: 0px 30px 20px 20px;
  `
};